import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const FAQ = () => {
    const [activeAccordion, setActiveAccordion] = useState(0);

    const handleAccordionClick = (index) => {
        if (activeAccordion === index) {
            setActiveAccordion(null);
        } else {
            setActiveAccordion(index);
        }
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const faqs = [
        {
            question: "Who can join these classes?",
            answer: "We welcome children   and adults of all levels, from complete beginners to advanced students. Everyone can start at their own pace."
        },
        {
            question: "How are classes delivered?",
            answer: "All classes are live online (using Zoom or similar). You can choose one-to-one or small-group sessions. We schedule classes to suit UK time zones and school/work schedules."
        },
        {
            question: "Can I try a class for free?",
            answer: "Yes! We offer a free demo lesson so you can see how we teach before enrolling. Just contact us to book your free trial."
        },
        {
            question: "What qualifications do the teachers have?",
            answer: "Our tutors are certified in Tajweed and Quranic teaching, with extensive experience in online education. We have both male and female teachers to suit your preference."
        }
    ];

    return (
        <div className="faq-section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="wpo-section-title text-center">
                            <span>Questions & Answers</span>
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="wpo-faq-section">
                            {faqs.map((faq, index) => (
                                <div 
                                    key={index} 
                                    className={`wpo-faq-item ${activeAccordion === index ? 'active' : ''}`}
                                    onClick={() => handleAccordionClick(index)}
                                >
                                    <h4 className="wpo-faq-question">
                                        {faq.question}
                                        <span className="accordion-icon">
                                            {activeAccordion === index ? '-' : '+'}
                                        </span>
                                    </h4>
                                    <div className={`wpo-faq-answer ${activeAccordion === index ? 'show' : ''}`}>
                                        <p>{faq.answer}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="faq-btn-wrapper text-center">
                            <p>Have more questions? We're here to help!</p>
                            <Link onClick={ClickHandler} to="/contact" className="theme-btn">Contact Us</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ; 